// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nqJ1","fullView":"styles_fullView__1D9la"};